// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { useState, useCallback } from 'react'
import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LANGUAGES, type Language } from './config'
import i18n from './index'

const STORAGE_KEY = 'qh_lang'

function resolveInitial(): Language {
  const stored = sessionStorage.getItem(STORAGE_KEY)
  return (
    SUPPORTED_LANGUAGES.find(l => l.code === stored) ??
    SUPPORTED_LANGUAGES.find(l => l.code === DEFAULT_LANGUAGE_CODE) ??
    SUPPORTED_LANGUAGES[0]!
  )
}

export function useLanguage() {
  const [current, setCurrent] = useState<Language>(resolveInitial)

  const setLanguage = useCallback((code: string) => {
    const lang = SUPPORTED_LANGUAGES.find(l => l.code === code)
    if (!lang) return
    sessionStorage.setItem(STORAGE_KEY, code)
    document.documentElement.dir = lang.dir
    void i18n.changeLanguage(code)
    setCurrent(lang)
  }, [])

  return { current, setLanguage, languages: SUPPORTED_LANGUAGES }
}
